import {ModalDialog, Page, PageContentTitle} from "../../ui"
import {observer} from "mobx-react"
import {VdaForm, VdaFormValidation} from "./VdaForm";
import {
    cmsCreateStore,
    DialogStore,
    growlStore,
    validationStore,
    vdaCreateStore,
    vdaCustomerStore,
    vdaDetailStore, vdaPlacementStore
} from "../../../store";
import {useNavigate} from "react-router";
import {useState} from "react";

const VdaCreatePage = observer(function VdaCreatePage() {
    const navigate = useNavigate()
    const [cancelDialog] = useState(new DialogStore())
    const display = 'Neues Fahrzeug erfassen'

    const validation: VdaFormValidation = {
        customer: validationStore.getFor('customer') || validationStore.getFor('customerId'),
        placement: validationStore.getFor('placementProcessId'),
        vin: validationStore.getFor('vin'),
        vinCheckDigit: validationStore.getFor('vinCheckDigit'),
        documents: validationStore.getFor('documents'),
        errorByDocument: validationStore.getErrorForDocuments(),
    }

    return <Page
        breadcrumb={[
            {
                link: '/vda',
                label: `Fahrzeugerfassung`
            },
            {
                link: '/vda/create',
                label: display
            },
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        cmsCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate('/vda')
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${vdaCreateStore.creating ? 'is-loading' : ''}`,
                    disabled: !(vdaCreateStore.dirty && vdaCreateStore.valid),
                    action: async () => {
                        const id = await vdaCreateStore.create()
                        if (!id) {
                            growlStore.add({
                                message: 'Das Fahrzeug konnte nicht erfasst werden',
                                autoclose: 1000,
                                cls:'is-danger',
                                closable: true
                            })
                            return
                        }
                        vdaCreateStore.reset()
                        growlStore.add({
                            message: 'Das Fahrzeug wurde erfasst',
                            autoclose: 1000,
                            closable: true
                        })
                        navigate(`/vda/${id}`)
                    }
                }, {
                    label: 'Speichern und Erfassung abschließen',
                    cls: `is-primary ${vdaCreateStore.creating ? 'is-loading' : ''}`,
                    disabled: !(vdaCreateStore.dirty && vdaCreateStore.valid),
                    action: async () => {
                        const id = await vdaCreateStore.create()
                        if (!id) {
                            growlStore.add({
                                message: 'Das Fahrzeug konnte nicht erfasst werden',
                                autoclose: 1000,
                                cls:'is-danger',
                                closable: true
                            })
                            return
                        }

                        vdaDetailStore.id = id

                        await vdaDetailStore.load()

                        await vdaDetailStore.transfer()

                        growlStore.add({
                            message: 'Das Fahrzeug wurde erfasst',
                            autoclose: 1000,
                            closable: true
                        })
                        vdaCreateStore.resetAndReuse()
                    }
                }, {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: vdaCreateStore.creating || !vdaCreateStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <VdaForm
            validation={validation}
            leadingLicensePlate={vdaCreateStore.leadingLicensePlate}
            placements={vdaPlacementStore.items}
            customers={vdaCustomerStore.items}
            value={vdaCreateStore.formData}
            onChange={data => vdaCreateStore.formData = data}
            onBlur={() => vdaCreateStore.validate()}
            onSearchCustomer={async (query) => await vdaCustomerStore.search(query)}
        />
    </Page>
})

export {
    VdaCreatePage
}
